import graphql__327f6343bb434655700e from "./__generated__/ContributionsDatavizList_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";

import ContributionsDatavizRootLayout from "./ContributionsDatavizRootLayout";
import ContributionsDatavizListItems from "./ContributionsDatavizListItems";

const ContributionsDatavizList = props => {
  const participativeModule = useFragment(
    ContributionsDatavizList_participativeModule,
    props.participativeModule
  );

  return (
    <ContributionsDatavizRootLayout
      participativeModule={participativeModule}
      listViewActive={true}
    >
      <ContributionsDatavizListItems participativeModule={participativeModule} />
    </ContributionsDatavizRootLayout>
  );
};

const ContributionsDatavizList_participativeModule = graphql__327f6343bb434655700e;

export default ContributionsDatavizList;
